import React, { FC, useState, useEffect } from 'react';
import EmailIcon from '@mui/icons-material/Email';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Typography, Checkbox } from '@mui/material';
import { Author } from '@graphql/types';
import { Link } from 'react-router-dom';
import { TitleLink } from '@components/UI/styled';
import {AUTHORS_ITEM} from './AuthorsItem.consts'
import {
    ItemWrapper,
    Title,
    AuthorContent,
    AuthorInfo,
    EmailWrapper
} from './AuthorsItem.styles'


type AuthorItemProps = {
    author: Author;
    deactivateAuthorAction: (uid: string) => void;
    activateAuthorAction: (uid: string) => void;
};

const AuthorsItem: FC<AuthorItemProps> = ({ author, deactivateAuthorAction, activateAuthorAction }) => {
    const [isActive, setIsActive] = useState(author.isActive);
    const [iStatus, setStatus] = useState(author.status);

    useEffect(() => {
        setIsActive(author.isActive);
    }, [author.isActive]);

    useEffect(() => {
        setStatus(author.status);
    }, [author.status]);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newIsActive = event.target.checked;
        setIsActive(newIsActive);

        if (newIsActive) {
            activateAuthorAction(author.uid);
        } else {
            deactivateAuthorAction(author.uid);
        }
    };

    return (
        <ItemWrapper isActive={iStatus}>
            <Checkbox
                checked={isActive}
                onChange={handleCheckboxChange}
                color="primary"
            />
            <AuthorContent>
                <AuthorInfo>
                    <Title>
                        <TitleLink to={`/author/editor/${author.uid}`} title={AUTHORS_ITEM.editAuthor} color="secondary">
                            {author.lastName} {author.firstName} {author.status && AUTHORS_ITEM.isFired}
                        </TitleLink>
                    </Title>
                    <Typography color="secondary" component="span" variant="subtitle1">
                        {author.jobTitle}
                        {author.editor?.name && author.jobTitle && (
                            <>
                                <span> • </span>
                            </>
                        )}
                        {author.editor?.name}
                    </Typography>
                </AuthorInfo>

                <EmailWrapper>
                    {author.mail && (
                        <>
                    <EmailIcon color="primary" style={{ marginRight: '4px' }} />
                    {author.mail}
                        </>
                    )}
                </EmailWrapper>
            </AuthorContent>

            <IconButton
                component={Link}
                to={`/author/editor/${author.uid}`}
                style={{ marginLeft: 'auto' }}
            >
                <EditIcon color="disabled" />
            </IconButton>
        </ItemWrapper>
    );
};

export default AuthorsItem;
